import React from 'react';

import Button from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/core/add';

import type { CreateButtonProps } from './types';

export const CreateButton = (props: CreateButtonProps) => {
	const { text, onClick } = props;

	return (
		<Button appearance="primary" iconBefore={AddIcon} onClick={onClick}>
			{text}
		</Button>
	);
};
